import React from "react";
import Slider from "@mui/material/Slider";
import "../../Assets/styles/newStyles/CustomSlider.css";

export const CustomSlider = (props) => {
  const styles = {
    color: "#e9eaee",

    width: "400px",
    height: "8px",
    cursor: props.disabled ? "not-allowed" : "pointer",
    "& .MuiSlider-track": {
      // border: 'none',
      color: "#FF7D00",
    },
    "& .MuiSlider-thumb": {
      height: 0,
      width: 0,
      backgroundColor: "#F2F4F7",
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1,
      fontSize: 10,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#52af77",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&:before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },

    "& .MuiSlider-mark": {
      backgroundColor: "#F2F4F7",
      height: 8,
      width: 0.002,
      "&.MuiSlider-markActive": {
        // opacity: 1,
        backgroundColor: "#F2F4F7",
      },
    },
    "& .MuiSlider-markLabel": {
      top: 30,
      fontSize: 13,
      color: "#b2b2b2",
    },
  };
  const marks = [
    {
      value: 0,
      label: "Low",
    },
    {
      value: 1,
      label: "Medium",
    },
    {
      value: 2,
      label: "High",
    },
  ];
  return (
    <div className="custom-slider-main-container">
      <div className="slider-prefix">{props.prefix}</div>
      <div className="slider-sensitivity-container">
      <p
          style={{
            color: "#FF7D00",
            paddingBottom: "8px",
            cursor: props.disabled ? "not-allowed" : "pointer", // Conditionally apply cursor style
          }}
          onClick={() => !props.disabled && props.handleButton(true, false)} // Prevent onClick when disabled
        >
          -
        </p>
        <div>
          <h5 className="slider-sensitivity">{props.heading}</h5>
          <Slider
            sx={styles}
            value={props.value}
            onChange={props.handleChange}
            valueLabelDisplay="auto"
            step={1}
            marks={marks}
            min={0}
            max={2}
          />
        </div>
        <p
          style={{
            color: "#FF7D00",
            paddingBottom: "8px",
            cursor: props.disabled ? "not-allowed" : "pointer", // Conditionally apply cursor style
          }}
          onClick={() => !props.disabled && props.handleButton(true, false)} // Prevent onClick when disabled
        >
          +
        </p>
      </div>
    </div>
  );
};